import type { SerializedAllFeaturesEditorState } from '@/admin/lexical/features'
import type { Maybe } from '@/frontend-types'
import type { FC } from 'react'
import type { ContactDetailListProps } from '../molecules/ContactDetailList'
import { ContactDetailList } from '../molecules/ContactDetailList'
import ContentBlockWrapper from '../molecules/ContentBlockWrapper'
import { SubscribeForm } from '../molecules/SubscribeForm'

export type SubscribeFormBlockProps = ContactDetailListProps & {
	termsAndConditions?: Maybe<SerializedAllFeaturesEditorState>
}

export const SubscribeFormBlock: FC<SubscribeFormBlockProps> = ({
	termsAndConditions,
	...props
}) => {
	return (
		<ContentBlockWrapper blockTypes={['standalone']} gridClassName="gap-y-5xl">
			<div className="col-span-full flex flex-col gap-y-4xl layout-narrow:tablet-l:col-span-full layout-wide:tablet-l:col-span-6">
				<h2 className="text-h3 text-blue" id="subscribe">
					Subscribe for updates
				</h2>
				<SubscribeForm termsAndConditions={termsAndConditions} />
			</div>
			<div className="col-span-full flex flex-col gap-y-4xl layout-narrow:tablet-l:col-span-full layout-wide:tablet-l:col-span-4 layout-wide:tablet-l:col-start-9">
				<h2 className="text-h3 text-blue">Get in touch</h2>
				<ContactDetailList {...props} />
			</div>
		</ContentBlockWrapper>
	)
}

export default SubscribeFormBlock
